import { BaseRequest } from './BaseRequest';

export class ThumbnailRequest extends BaseRequest {
  height;
  width;
  position = 'thumbnail';

  constructor (width, height) {
    super();
    this.width = width;
    this.height = height;
  }

  getUrl (builder) {
    return builder.thumb(this.width, this.height);
  }
}
